import { createContext, useContext } from 'react';

interface GTContextValue {
  itemHeight: number;
}

const GTContext = createContext<GTContextValue>({ itemHeight: 77 });

export const GTProvider = GTContext.Provider;

export const useGTContext = () => useContext(GTContext);
